import { EnterpriseMemberPermission, PermissionUtils } from '../services/AccountServer/types'

interface GlossaryUser {
  id?: number | string | null
  bizTeamId?: number | string | null
  bizMemberpermission?: number | null
}

/** 只在服务端用户身份就绪后查询；普通资料刷新不改变查询上下文。 */
export function enterpriseGlossaryContext(ready: boolean, user: GlossaryUser): string | null {
  const id = Number(user?.id)
  if (!ready || !Number.isFinite(id) || id <= 0) return null
  return `${id}:${user.bizTeamId || ''}:${user.bizMemberpermission || 0}`
}

/** 编辑权限可维护共享术语表；无权限时仍保留本人维护能力。 */
export function canModifyEnterpriseGlossary(record: { userId?: number | string | null }, user: GlossaryUser): boolean {
  const id = Number(user?.id)
  if (!Number.isFinite(id) || id <= 0) return false
  return PermissionUtils.hasPermission(user.bizMemberpermission || 0, EnterpriseMemberPermission.TERM_EDIT) || Number(record?.userId) === id
}
